var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// @ts-nocheck
import { getAuthStore } from '@dev-togetherprice/api.auth';
import wrapPromise from '@dev-togetherprice/utils.wrap-promise';
import jwtDecode from 'jwt-decode';
import React, { useEffect, useState, useCallback, useMemo, useRef, } from 'react';
import { SWRConfig } from 'swr';
const swrKeyMap = new Map();
const TEMP_USER_ID = '6db57a3c';
// TODO: support array keys too
const getNewKey = (key, userId) => {
    if (typeof key === 'object')
        throw new Error('Arrays are not supported! If the array support is wanted then it can be added in TPSWRConfig file');
    // if there is no user id, do not go forward
    // if there is no key then it should not call be so pass key again
    if (!userId || !key)
        return key;
    switch (typeof key) {
        case 'string':
            return [userId, key].filter(Boolean).join('-');
        case 'function':
            return (props) => {
                const generatedKey = key(props);
                return getNewKey(generatedKey, userId);
            };
        default:
            return key;
    }
};
// gets auth token from storage and extract user id from token
const getUserId = () => {
    return getAuthStore().then((value) => {
        if (!value)
            return null;
        const { token = '' } = value;
        if (!token)
            return null;
        const cachedValue = swrKeyMap.get(token);
        if (cachedValue)
            return cachedValue;
        const { sub = '' } = jwtDecode(token);
        if (!sub)
            return null;
        swrKeyMap.set(token, sub);
        return sub;
    });
};
const getUserIdPromise = () => {
    const userId = getUserId();
    return wrapPromise(userId);
};
// resource for suspended user id
let userResource = getUserIdPromise();
const keyGenerator = (useSWRNext) => (key, fetcher, config) => {
    /** For suspense components, fetch id in a suspense mode
     * userResource is memoized so it will return same id always
     * so it needs to be updated whenever id is changes
     * */
    const defaultUserId = (config === null || config === void 0 ? void 0 : config.suspense) && userResource.read();
    const [userId, setUserId] = useState(defaultUserId || TEMP_USER_ID);
    const [isReady, setIsReady] = useState(false);
    const timerRef = useRef();
    useEffect(() => {
        getUserId()
            .then((id) => {
            // update user id only if id is defined. Otherwise we will lose default id
            if (id)
                setUserId(id);
            // update memoized value to have correct data for next calls
            if (id && defaultUserId !== id)
                userResource = getUserIdPromise();
        })
            .catch(null)
            .finally(() => setIsReady(true));
    }, [key, config === null || config === void 0 ? void 0 : config.suspense]);
    useEffect(() => () => {
        // remove timer
        if (timerRef.current)
            clearTimeout(timerRef.current);
    }, [isReady]);
    const newKey = useMemo(() => getNewKey(key, userId), [key, userId]);
    // fake fetcher will let us to avoid multiple be calls until user id is ready
    const fakeFetcher = useCallback((_) => new Promise((_, reject) => {
        // to not block user for forever
        const timer = setTimeout(() => {
            reject(new Error('Timeout'));
        }, 15000);
        timerRef.current = timer;
    }), [config === null || config === void 0 ? void 0 : config.suspense]);
    const extractUserId = useCallback((k) => {
        // extract user id from key to get real key
        const uidStructure = `${userId}-`;
        if (userId && k.startsWith(uidStructure))
            return k.split(uidStructure)[1];
        return k;
    }, [userId]);
    // isReady conditions are important, otherwise it will call be for more than one time
    return useSWRNext(isReady || (config === null || config === void 0 ? void 0 : config.suspense) ? newKey : key, isReady || (config === null || config === void 0 ? void 0 : config.suspense)
        ? (k) => fetcher === null || fetcher === void 0 ? void 0 : fetcher(extractUserId(k))
        : fakeFetcher, config);
};
const TPSWRConfig = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(SWRConfig, { value: Object.assign({ revalidateOnMount: true, revalidateOnFocus: false, refreshWhenOffline: false, refreshWhenHidden: false, dedupingInterval: 8000, use: [keyGenerator] }, props) }, children));
};
export default TPSWRConfig;
